import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useSnapshot } from 'valtio'
import { windowSizeState } from '../utils/windowSize'
import { proxyState } from '../App'

// image
import enTitle from '../assets/image/20230413_compuer UI -86.png'
import leftTree from '../assets/image/20230413_compuer UI -94.png'
import leftTopPeople from '../assets/image/20230413_compuer UI -87.png'
import middleTopPeople from '../assets/image/20230413_compuer UI -88.png'
import rightTopPeople from '../assets/image/20230413_compuer UI -89.png'
import leftBottomPeople from '../assets/image/20230413_compuer UI -91.png'
import rightBottomPeople from '../assets/image/20230413_compuer UI -90.png'
import infoPeople from '../assets/image/89-89-89.png'
import visitButton from '../assets/image/visit1-28.png'
import title1 from '../assets/image/title1-26.png'
import title2 from '../assets/image/title2-27.png'
import detail from '../assets/image/20230413_compuer UI -92.png'
import subtitle from '../assets/image/20230413_compuer UI -93.png'
import middleTopTree from '../assets/image/20230413_compuer UI -95.png'
import middleBottomTree from '../assets/image/20230413_compuer UI -96.png'
import mobileEnTitle from '../assets/image/20230328_ phone ui-79.png'
import mobileDetail from '../assets/image/20230328_ phone ui-84.png'
import rotateImage from '../assets/image/ph.png'

const Homepage = () => {
  const { visible } = useSnapshot(proxyState.homepage)
  const [isBgAnimationComplete, setIsBgAnimationComplete] = useState(false)
  const { mobileMode } = useSnapshot(windowSizeState)
  const handleChangePage = () => {
    proxyState.homepage.visible = false
    proxyState.infoPage.visible = true
  }

  // 主背景動畫結束後才出現按鈕
  const handleDisplayButton = () => {
    setTimeout(() => {
      setIsBgAnimationComplete(true)
    }, 500)
  }

  const backgroundVariants = {
    show: {
      opacity: [0, 0.5, 1],
      transition: {
        duration: 3,
        delay: 0.6,
      },
    },
    hidden: {
      opacity: 0,
    },
  }

  const title1Variants = {
    show: {
      x: 0,
      y: [-400, -80, -200, -40, -100, 0, -20, 0, -10, 0],
      scale: [1, 0.95, 1, 0.95, 1, 0.95, 1, 1, 1, 1],
      transition: {
        duration: 1.8,
        delay: 2.8,
        times: mobileMode
          ? [0, 0.2, 0.5, 0.63, 0.78, 0.83, 0.88, 0.92, 0.95, 1]
          : [0, 0.2, 0.5, 0.6, 0.78, 0.83, 0.88, 0.92, 0.95, 1],
      },
    },
    hidden: {
      x: mobileMode ? '-100vw' : '-50vw',
      y: -400,
    },
  }
  const title2Variants = {
    show: {
      x: 0,
      y: [-400, -80, -200, -40, -100, 0, -20, 0, -10, 0],
      scale: [1, 0.97, 1, 0.97, 1, 0.97, 1, 1, 1, 1],
      transition: {
        duration: 1.8,
        delay: 4.8,
        times: mobileMode
          ? [0, 0.2, 0.5, 0.63, 0.78, 0.83, 0.88, 0.92, 0.95, 1]
          : [0, 0.2, 0.5, 0.6, 0.78, 0.83, 0.88, 0.92, 0.95, 1],
      },
    },
    hidden: {
      x: mobileMode ? '-100vw' : '-50vw',
      y: -400,
    },
  }
  const visitVariants = {
    show: {
      rotate: [3, -3, 3],
      transition: {
        duration: 0.8,
        repeat: Infinity,
      },
      willChange: 'transform', // 加入 willChange 屬性
      layout: 'position', // 加入 layout 屬性
    },
  }

  const visitHoverVariants = {
    opacity: 1,
    rotate: [3, -3, 3],
    transition: {
      duration: 0.3,
      repeat: Infinity,
    },
    willChange: 'transform', // 加入 willChange 屬性
    layout: 'position', // 加入 layout 屬性
  }

  return (
    <>
      <div className='main-background h-screen w-screen overflow-hidden landscapePhone:hidden fixed z-10'></div>
      <AnimatePresence>
        {visible && (
          <>
            <motion.div
              className='main-background h-screen w-screen fixed z-20 overflow-hidden landscapePhone:hidden'
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
            >
              <motion.img
                src={!mobileMode ? enTitle : mobileEnTitle}
                alt='主背景英文標題'
                className='absolute w-[25%] top-16 left-32 xxl:left-28 mdLg:w-[43%] mdLg:top-4 mdLg:left-[9%] sm:w-[46%]'
                variants={backgroundVariants}
                initial='hidden'
                animate='show'
              />
              <motion.img
                src={leftTree}
                alt='主背景左邊的樹'
                className='absolute w-[5%] top-[45%] left-12 mdLg:w-[10%] mdLg:top-[40%] mdLg:left-[10%] sm:top-[33%] sm:left-[5%]'
                variants={backgroundVariants}
                initial='hidden'
                animate='show'
              />
              <motion.img
                src={middleTopTree}
                alt='主背景中上的樹'
                className='absolute w-[4%] top-[50%] left-[32%] mdLg:w-[9%] mdLg:left-[85%] mdLg:top-[46%] sm:top-[40%] sm:left-[87%]'
                variants={backgroundVariants}
                initial='hidden'
                animate='show'
              />
              <motion.img
                src={middleBottomTree}
                alt='主背景中下的樹'
                className='absolute w-[5%] top-[72%] left-[32%] mdLg:w-[10%] mdLg:top-[58%] mdLg:left-[6%] sm:top-[56%]'
                variants={backgroundVariants}
                initial='hidden'
                animate='show'
              />
              {!mobileMode && (
                <motion.img
                  src={leftTopPeople}
                  alt='主背景左上的人'
                  className='absolute w-[12%] top-16 left-[43%] xxl:w-[14%] xl:w-[16%] lg:w-[18%]'
                  variants={backgroundVariants}
                  initial='hidden'
                  animate='show'
                />
              )}
              {!mobileMode && (
                <motion.img
                  src={middleTopPeople}
                  alt='主背景中上的人'
                  className='absolute w-[16%] top-20 right-[25%] xxl:w-[21%] xxl:right-[20%] xl:w-[25%] xl:right-[17%] lg:w-[24%] lg:right-[17%] lg:top-32'
                  variants={backgroundVariants}
                  initial='hidden'
                  animate='show'
                />
              )}
              <motion.img
                src={!mobileMode ? rightTopPeople : infoPeople}
                alt='主背景右上的人'
                className='absolute w-[14%] top-4 right-[7%] xl:w-[16%] xl:right-[5%] xl:top-8 mdLg:top-[3%] mdLg:w-[19%] mdLg:right-[17%] sm:w-[24%]'
                variants={backgroundVariants}
                initial='hidden'
                animate='show'
              />
              {!mobileMode && (
                <motion.img
                  src={leftBottomPeople}
                  alt='主背景左下的人'
                  className='absolute w-[22%] bottom-32 right-[28%] xl:w-[26%]'
                  variants={backgroundVariants}
                  initial='hidden'
                  animate='show'
                />
              )}
              {!mobileMode && (
                <motion.img
                  src={rightBottomPeople}
                  alt='主背景右下的人'
                  className='absolute w-[14%] bottom-[30%] right-[7%]  xxl:w-[17%] xl:w-[19%] xl:bottom-[28%]'
                  variants={backgroundVariants}
                  initial='hidden'
                  animate='show'
                />
              )}
              <motion.img
                src={title1}
                alt='移路'
                className='absolute w-[25%] top-[24%] left-[7%] xl:w-[34%] mdLg:w-[58%] mdLg:top-[13%] mdLg:left-[22%] md:w-[64%] md:left-[21%] smMd:w-[70%] smMd:left-[18%] sm:w-[70%] sm:left-[15%] sm:top-[13%]'
                variants={title1Variants}
                initial='hidden'
                animate='show'
              />
              <motion.img
                src={title2}
                alt='相伴'
                className='absolute w-[25%] top-[51%] left-[7%] xl:w-[34%] mdLg:w-[58%] mdLg:top-[42%] mdLg:left-[22%] md:w-[64%] md:left-[21%] smMd:w-[70%] smMd:left-[18%] sm:w-[70%] sm:left-[15%] sm:top-[38%]'
                variants={title2Variants}
                initial='hidden'
                animate='show'
                onAnimationComplete={handleDisplayButton}
              />
              <motion.img
                src={!mobileMode ? detail : mobileDetail}
                alt='指導單位'
                className='absolute w-[46%] bottom-12 left-[7%] xl:w-[48%] mdLg:bottom-6 smMd:w-[56%]'
                variants={backgroundVariants}
                initial='hidden'
                animate='show'
              />
              {!mobileMode && (
                <motion.img
                  src={subtitle}
                  alt='副標'
                  className='absolute w-[20%] bottom-28 left-[7%] xl:bottom-24 xl:w-[27%] mdLg:w-[150%] mdLg:left-[0%]'
                  variants={backgroundVariants}
                  initial='hidden'
                  animate='show'
                />
              )}
              {mobileMode && (
                <motion.div
                  variants={backgroundVariants}
                  initial='hidden'
                  animate='show'
                  className='text-[18px] text-orangeFont-100 bg-subtitleBackground-100 py-4 px-12 absolute bottom-28 w-full font-bold tracking-wider sm:text-[17px] sm:bottom-20 sm:px-6'
                >
                  <p>高 屏 地 區</p>
                  <p>移 動 人 權 特 展</p>
                  <p>Special Exhibition on the Human Rights of</p>
                  <p>Migrants in Kaohsiung & Pingtung</p>
                </motion.div>
              )}
              {isBgAnimationComplete && (
                <motion.img
                  src={visitButton}
                  alt='參觀展覽按鈕'
                  className='absolute w-[20%] right-16 bottom-20 cursor-pointer  xxl:w-[22%] xl:w-[23%] xl:bottom-16 mdLg:w-[38%] mdLg:bottom-[16%] mdLg:right-[6%] md:w-[50%] md:bottom-[20%] smMd:bottom-[25%] sm:bottom-[33%] sm:w-[55%] xs:bottom-[10%]'
                  variants={visitVariants}
                  animate='show'
                  whileHover={visitHoverVariants}
                  onClick={handleChangePage}
                />
              )}
            </motion.div>
            <div className='main-background h-screen hidden justify-center items-center portrait:hidden landscapePhone:flex '>
              <img
                src={rotateImage}
                alt=''
                className='w-[70%] h-[70%] object-contain'
              />
            </div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}

export default Homepage
